exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*.topPanel {*/\n/*    width: 100%;*/\n/*    height: 50px;*/\n/*    background: #282c34;*/\n/*}*/\n", ""]);

